export default __webpack_public_path__ + "static/media/Hemkunskap2.4099b489.jpeg";